export default "__VITE_ASSET__BkVGF63I__"